// extracted by mini-css-extract-plugin
export default {"panelContainer":"TabPanel_panelContainer__CBtTX"};